(function () {
  const revealSelectors = [
    '.btcfq-home-hero__inner',
    '.btcfq-home-path__heading',
    '.btcfq-home-path__list > *',
    '.btcfq-home-search-section__inner',
    '.btcfq-home-section-header',
    '.btcfq-faq-list > *',
    '.btcfq-term-grid > *',
    '.btcfq-guide-band',
    '.btcfq-article-grid > *',
    '.btcfq-home-cta-grid > *',
    '.btcfq-start-hero__copy',
    '.btcfq-start-hero__visual',
    '.btcfq-start-overview',
    '.btcfq-start-step',
    '.btcfq-start-next',
    '.btcfq-faq-page__aside',
    '.btcfq-faq-page__summary',
    '.btcfq-faq-page__list > *',
    '.btcfq-glossary-page__alphabet',
    '.btcfq-glossary-page__count',
    '.btcfq-glossary-page__grid > *',
    '.btcfq-blog-hero__inner',
    '.btcfq-blog-featured',
    '.btcfq-blog-filters',
    '.btcfq-blog-grid > *',
    '.btcfq-blog-newsletter',
    '.btcfq-article-hero__inner',
    '.btcfq-article-image',
    '.btcfq-article-footer > *',
    '.btcfq-article-related__header',
    '.btcfq-article-related__grid > *',
    '.btcfq-about-hero__inner',
    '.btcfq-about-values > *',
    '.btcfq-about-coverage > *',
    '.btcfq-about-cta',
    '.btcfq-contact__intro',
    '.btcfq-contact-form',
    '.btcfq-contact-success',
    '.btcfq-ask__intro',
    '.btcfq-ask-form',
    '.btcfq-ask-success',
    '.btcfq-404__copy',
    '.btcfq-404__panel',
    '.btcfq-404-links > *',
    '.btcfq-footer'
  ];

  const staggerParents = [
    '.btcfq-faq-list',
    '.btcfq-term-grid',
    '.btcfq-article-grid',
    '.btcfq-faq-page__list',
    '.btcfq-glossary-page__grid',
    '.btcfq-blog-grid',
    '.btcfq-article-footer',
    '.btcfq-article-related__grid',
    '.btcfq-about-values',
    '.btcfq-about-coverage',
    '.btcfq-home-cta-grid',
    '.btcfq-home-path__list',
    '.btcfq-404-links'
  ];

  let revealObserver = null;

  function initLessonLearning() {
    const storageKey = 'btcfq-completed-lessons';
    let completed = [];
    try {
      const saved = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      completed = Array.isArray(saved)
        ? Array.from(new Set(saved.map(String).filter(function (lessonNumber) {
          return ['1', '2', '3', '4', '5', '6'].indexOf(lessonNumber) !== -1;
        })))
        : [];
    } catch (error) {
      completed = [];
    }

    document.querySelectorAll('[data-btcfq-lesson-link]').forEach(function (link) {
      const status = link.querySelector('[data-btcfq-lesson-status]');
      const isComplete = completed.indexOf(String(link.dataset.lessonNumber)) !== -1;
      if (status) status.textContent = isComplete ? 'Complete' : '';
      if (isComplete) link.classList.add('is-complete');
    });
    document.querySelectorAll('[data-btcfq-course-progress]').forEach(function (progress) {
      const total = Number(progress.dataset.totalLessons) || 6;
      const count = Math.min(completed.length, total);
      const meter = progress.querySelector('progress');
      const label = progress.querySelector('[data-btcfq-progress-label]');
      if (meter) meter.value = count;
      if (label) label.textContent = count + ' of ' + total + ' lessons complete';
    });

    document.querySelectorAll('[data-btcfq-quiz]').forEach(function (quiz) {
      if (quiz.dataset.initialized === 'true') return;
      const submit = quiz.querySelector('[data-btcfq-quiz-submit]');
      const feedback = quiz.querySelector('[data-btcfq-quiz-feedback]');
      const explanation = quiz.querySelector('[data-btcfq-quiz-explanation]');
      if (!submit || !feedback || !explanation) return;
      quiz.dataset.initialized = 'true';

      submit.addEventListener('click', function () {
        const selected = quiz.querySelector('input[type="radio"]:checked');
        if (!selected) {
          feedback.textContent = 'Choose an answer first.';
          feedback.dataset.result = 'incorrect';
          feedback.hidden = false;
          return;
        }

        const isCorrect = selected.value === quiz.dataset.correctOption;
        feedback.textContent = isCorrect ? 'That’s right. Lesson complete!' : 'Not quite. Review the explanation and try again.';
        feedback.dataset.result = isCorrect ? 'correct' : 'incorrect';
        feedback.hidden = false;
        explanation.hidden = false;

        if (isCorrect) {
          quiz.dataset.btcfqCompleted = 'true';
          const lessonNumber = String(quiz.dataset.lessonNumber);
          if (completed.indexOf(lessonNumber) === -1) completed.push(lessonNumber);
          try {
            window.localStorage.setItem(storageKey, JSON.stringify(completed));
          } catch (error) {
            // The quiz still works when browser storage is unavailable.
          }
          document.querySelectorAll('[data-btcfq-lesson-link][data-lesson-number="' + lessonNumber + '"]').forEach(function (link) {
            const status = link.querySelector('[data-btcfq-lesson-status]');
            if (status) status.textContent = 'Complete';
            link.classList.add('is-complete');
          });
          document.querySelectorAll('[data-btcfq-course-progress]').forEach(function (progress) {
            const count = Math.min(completed.length, Number(progress.dataset.totalLessons) || 6);
            const meter = progress.querySelector('progress');
            const label = progress.querySelector('[data-btcfq-progress-label]');
            if (meter) meter.value = count;
            if (label) label.textContent = count + ' of ' + (Number(progress.dataset.totalLessons) || 6) + ' lessons complete';
          });
        }
      });
    });
  }

  function initTopicExplainers(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-btcfq-explainer]').forEach(function (explainer) {
      if (explainer.dataset.initialized === 'true') return;
      const buttons = Array.from(explainer.querySelectorAll('[data-explainer-step]'));
      const panel = explainer.querySelector('[data-explainer-copy]');
      const stages = Array.from(explainer.querySelectorAll('[data-diagram-stage]'));
      if (!buttons.length || !panel) return;
      explainer.dataset.initialized = 'true';
      function select(button) {
        buttons.forEach(function (item) {
          const active = item === button;
          item.setAttribute('aria-pressed', String(active));
          const stage = item.dataset.explainerStep;
          stages.forEach(function (node) { node.classList.toggle('is-active', node.dataset.diagramStage === stage); });
        });
        explainer.dataset.activeStep = button.dataset.explainerStep;
        panel.textContent = button.dataset.explainerDescription;
      }
      buttons.forEach(function (button) { button.addEventListener('click', function () { select(button); }); });
      select(buttons[0]);
    });

  }

  function initMobileLessonNav(root) {
    const scope = root || document;
    if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
      scope.querySelectorAll('.btcfq-lesson-sidebar [data-btcfq-lesson-link][aria-current="page"]').forEach(function (link) {
        link.scrollIntoView({
          block: 'nearest',
          inline: 'center',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    }
  }

  function initFeedbackButtons() {
    document.querySelectorAll('[data-btcfq-feedback-button]').forEach(function (button) {
      if (button.dataset.btcfqFeedbackInitialized === 'true') return;

      button.dataset.btcfqFeedbackInitialized = 'true';

      button.addEventListener('click', function () {
        const feedback = button.closest('[data-btcfq-feedback]');
        if (!feedback) return;

        feedback.querySelectorAll('[data-btcfq-feedback-button], .btcfq-faq-item__feedback-question').forEach(function (node) {
          node.hidden = true;
        });

        const thanks = feedback.querySelector('.btcfq-faq-item__thanks');
        if (thanks) {
          thanks.hidden = false;
        }
      });
    });
  }

  function prepareRevealElements(root) {
    const scope = root || document;

    scope.querySelectorAll(revealSelectors.join(',')).forEach(function (element) {
      if (element.hasAttribute('data-btcfq-no-reveal')) return;
      if (!element.hasAttribute('data-btcfq-reveal')) {
        element.setAttribute('data-btcfq-reveal', 'pop');
      }
    });

    scope.querySelectorAll(staggerParents.join(',')).forEach(function (parent) {
      Array.from(parent.children).forEach(function (child, index) {
        if (child.hasAttribute('data-btcfq-no-reveal')) return;
        child.style.setProperty('--btcfq-reveal-delay', Math.min(index * 55, 330) + 'ms');
      });
    });
  }

  function observeRevealElements(root) {
    const scope = root || document;
    const elements = scope.querySelectorAll('[data-btcfq-reveal]:not(.is-visible)');

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.classList.add('is-visible');
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12
      });
    }

    elements.forEach(function (element) {
      revealObserver.observe(element);
    });
  }

  function initSectionEffects(root) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('[data-btcfq-reveal]').forEach(function (element) {
        element.classList.add('is-visible');
      });
      return;
    }

    prepareRevealElements(root || document);
    observeRevealElements(root || document);
  }

  function initTopicCarousel(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-btcfq-topic-carousel]').forEach(function (carousel) {
      if (carousel.dataset.btcfqInitialized === 'true') return;
      const track = carousel.querySelector('[data-btcfq-topic-track]');
      const group = track && track.querySelector('.btcfq-home-topics__group');
      if (!track || !group) return;
      carousel.dataset.btcfqInitialized = 'true';
      track.setAttribute('tabindex', '0');
      track.setAttribute('aria-label', 'Bitcoin learning topics');

      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        carousel.dataset.btcfqReducedMotion = 'true';
        return;
      }

      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach(function (link) {
        link.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);
      carousel.dataset.btcfqAnimate = 'true';
      document.addEventListener('visibilitychange', function () {
        carousel.dataset.btcfqPaused = String(document.hidden);
      });
    });
  }

  function initProductForms(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-btcfq-product-form]').forEach(function (container) {
      if (container.dataset.btcfqProductInitialized === 'true') return;
      const variants = container.querySelector('[data-btcfq-variant]');
      const submit = container.querySelector('[data-btcfq-add-to-cart]');
      const payment = container.querySelector('[data-btcfq-product-payment]');
      if (!variants || !submit) return;
      container.dataset.btcfqProductInitialized = 'true';

      function updateAvailability() {
        const option = variants.selectedOptions[0];
        const available = Boolean(option && !option.disabled);
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.availableLabel : submit.dataset.unavailableLabel;
        if (payment) payment.hidden = !available;
      }

      variants.addEventListener('change', updateAvailability);
      updateAvailability();
    });
  }

  function initBtcfq() {
    initTopicCarousel(document);
    initProductForms(document);
    initFeedbackButtons();
    initLessonLearning();
    initTopicExplainers(document);
    initMobileLessonNav(document);
    initSectionEffects(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBtcfq);
  } else {
    initBtcfq();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTopicCarousel(event.target);
    initProductForms(event.target);
    initFeedbackButtons();
    initLessonLearning();
    initTopicExplainers(event.target);
    initMobileLessonNav(event.target);
    initSectionEffects(event.target);
  });
})();
